import { createFetchClient } from "@marekl/adminer";
import { createRestAuthAdapter } from "@marekl/adminer/auth-rest-default";

// Lives outside main.tsx so both the entry point and the route tree can
// import it: with a data router, AdminerProvider moves inside the router
// (its LinkComponent renders <Link>), which puts it in App.tsx.
const apiClient = createFetchClient({ baseUrl: "/api" });

export const authAdapter = createRestAuthAdapter({ api: apiClient });
